export const CYCLE_REPORT = 'CycleReport';
export const GET_CYCLE_REPORT_TABLE_DATA = `${CYCLE_REPORT}/getCycleReportAction`;
export const GET_CYCLE_REPORT_DROP_DOWN = `${CYCLE_REPORT}/getCycleDropDownAction`;
export const GET_CYCLE_EXPORT_FILE = `${CYCLE_REPORT}/getCycleExportFileAction`;
